// extracted by mini-css-extract-plugin
module.exports = {"containerReport":"styles_containerReport__3Ncx4","inputs":"styles_inputs__3H1me"};